export default "__VITE_ASSET__OE5b$Koq__"